export const getFilters = (state) => state.filters
